import { render, staticRenderFns } from "./articleShareRCard.vue?vue&type=template&id=5ddfe2bb&scoped=true"
import script from "./articleShareRCard.vue?vue&type=script&lang=ts"
export * from "./articleShareRCard.vue?vue&type=script&lang=ts"
import style0 from "./articleShareRCard.vue?vue&type=style&index=0&id=5ddfe2bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfe2bb",
  null
  
)

export default component.exports